import {Locale, localeSchema} from '../../../api/types/carvagoApiTypes';

export const isLocale = (value: unknown): value is Locale => localeSchema.safeParse(value).success;
